import {
    Instance, SnapshotIn, types, flow, getEnv,
    SnapshotOut
} from 'mobx-state-tree';

import {
    GetDownloadablesParams,
    performDownloadDownloadables,
    performGetDownloadables,

} from '../service';
import { IStoresEnv } from '@core/storesEnv';
import { paginationStatusInitialState, PaginationStatusStore } from 'Users/stores/PaginationStatus.store';
import { DownloadableGroupStore } from './DownloadableGroup.store';
import { Id, toast } from 'react-toastify';


export const DownloadablesDataStoreInferred = types
    .model('DownloadableDataStore', {
        //downloadables: types.map(types.string,types.array(DownloadableStore)),
        downloadableGroups: types.array(DownloadableGroupStore),
        paginationStatus: types.optional(PaginationStatusStore, {}),
        selectedId: types.maybeNull(types.string),
        selectedFileName: types.optional(types.string, 'empty'),
    })
    .actions(self => {
        const { api } = getEnv<IStoresEnv>(self);

        const load = flow(function* (payload: GetDownloadablesParams) {
            const result = yield performGetDownloadables(api, {
                payload,
                errorHandlers: { DEFAULT: '' },
            });
            if (result.success) {
                self.downloadableGroups = result.data.entities ? result.data.entities : [];
                self.paginationStatus = result.data.meta ? result.data.meta : paginationStatusInitialState;
            }
        });

        const download = flow(function* (fileName: string, toastId: Id) {
            try {
                const result = yield performDownloadDownloadables(api, {
                    payload: { id: self.selectedId! },
                    errorHandlers: { DEFAULT: '' },
                });

                // 1. Check For success
                if (!result.success) {
                    toast.error(`Download failed (HTTP ${result.status})`);
                    toast.dismiss(toastId);

                    return;
                }

                // 2. Trigger download (UI layer)
                const downloadUrl = result.data.src;
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                link.style.display = 'none';

                // const newTab = window.open(downloadUrl, '_blank', 'noopener,noreferrer');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // if (!newTab) {
                //     // 3. Single download attempt
                //     document.body.appendChild(link);
                //     link.click();
                //     // 4. Cleanup - remove link after short delay
                //     setTimeout(() => {
                //         document.body.removeChild(link);
                //         window.URL.revokeObjectURL(link.href); // Important for blob URLs
                //     }, 1000); // 100ms is enough for the click to register
                // }

                // toast.dismiss(toastId);

            } catch (error: any) {
                toast.dismiss(toastId);
                toast.error(error.message || 'Download failed');
            }
        });

        return {
            load,
            download,
        }
    });

type DownloadablesDataStoreFactoryType = typeof DownloadablesDataStoreInferred;
interface IDownloadablesDataStoreFactory extends DownloadablesDataStoreFactoryType { }
export const DownloadablesDataStore: IDownloadablesDataStoreFactory = DownloadablesDataStoreInferred;
export interface IDownloadablesDataStore extends Instance<IDownloadablesDataStoreFactory> { }
export interface IDownloadablesDataStoreSnapshotIn extends SnapshotIn<IDownloadablesDataStore> { }
export interface IDownloadablesDataStoreSnaphotOut extends SnapshotOut<IDownloadablesDataStore> { }
